import {
    TransactionDetailRow,
    TransactionFeeSection,
    TransactionDialogContent,
    TransactionSection,
} from "@/components";
import { type UnwindingPositionStore, useCancelExitTransaction } from "@/hooks";
import { AssetIcon, Divider } from "@/components";
import { useCallback, useMemo } from "react";
import { formatDisplayCurrency } from "@/utils/format-currency";

export interface CancelExitTransactionProps {
    newUnwindingEpochs: number;
    unwindingTimestampMs: number;
    position: UnwindingPositionStore;
    onClose?: () => void;
}

export function CancelExitTransaction({
    newUnwindingEpochs,
    unwindingTimestampMs,
    position,
    onClose,
}: CancelExitTransactionProps) {
    const { gasPriceUSD, executeCancelExitTransaction, isLoading } = useCancelExitTransaction({
        newUnwindingEpochs,
        unwindingTimestampMs,
    });

    const handleConfirm = useCallback(async () => {
        try {
            await executeCancelExitTransaction();
            onClose?.();
        } catch (e) {
            console.error("Error executing cancel exit transaction:", e);
        }
    }, [executeCancelExitTransaction, onClose]);

    const CONFIRM_TEXT = "Confirm Cancel Withdrawal";

    const displayValues = useMemo(
        () => ({
            position: <AssetIcon name="LIUSD" size={24} className="mr-1" />,
            positionText: `liUSD-${position.lockDuration}`,
            amountToRemainLocked: `${formatDisplayCurrency(position.lockedBalance)} iUSD`,
            rewardsToRemainLocked: `${formatDisplayCurrency(position.rewardsEarned)} iUSD`,
        }),
        [position.lockDuration, position.lockedBalance, position.rewardsEarned],
    );

    return (
        <TransactionDialogContent
            isLoading={isLoading}
            onClose={onClose}
            onConfirm={handleConfirm}
            confirmText={CONFIRM_TEXT}
            className="w-[480px]"
        >
            <TransactionSection>
                <TransactionDetailRow
                    label="Position"
                    value={
                        <span className="inline-flex items-center">
                            {displayValues.position}
                            <span>{displayValues.positionText}</span>
                        </span>
                    }
                />
                <TransactionDetailRow label="Amount to Remain Locked" value={displayValues.amountToRemainLocked} />
                <TransactionDetailRow label="Rewards to Remain Locked" value={displayValues.rewardsToRemainLocked} />
                {/* <TransactionDetailRow label="Duration" value={`${newUnwindingEpochs} weeks`} /> */}
            </TransactionSection>
            <Divider />
            <TransactionFeeSection gasPriceUSD={gasPriceUSD} />
        </TransactionDialogContent>
    );
}
